import React, { useState } from 'react';
import { CreditCard, Plus, CheckCircle2, DollarSign, FileText } from 'lucide-react';

export const NDISBillingModule: React.FC = () => {
  const [invoices] = useState([
    { id: 'INV-2026-001', client: 'St. Jude School', amount: '$450.00', status: 'PAID', itemCode: '15_048_0128_1_3 (Speech Pathology)' },
    { id: 'INV-2026-002', client: 'Sunshine Therapy', amount: '$320.00', status: 'PENDING_APPROVAL', itemCode: '15_056_0128_1_3 (Occupational Therapy)' },
  ]);

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-green-100 text-green-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            Lumary & Splose Benchmark
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">NDIS & Clinical Insurance Billing Engine</h2>
          <p className="text-xs text-slate-500">NDIS support item code catalog, automated claim invoicing, and payment pipeline</p>
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider">Clinical Invoices & Claims Pipeline</h3>
        <div className="space-y-3">
          {invoices.map((inv) => (
            <div key={inv.id} className="p-4 bg-slate-50 border border-slate-200 rounded-xl flex items-center justify-between text-xs">
              <div>
                <div className="font-bold text-slate-900">{inv.id} - {inv.client}</div>
                <div className="text-[10px] text-slate-500 mt-0.5">Item Code: {inv.itemCode}</div>
              </div>
              <div className="text-right">
                <div className="text-sm font-black text-slate-900">{inv.amount}</div>
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded ${
                  inv.status === 'PAID' ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-100 text-amber-800'
                }`}>
                  {inv.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
